<div class="card">
  <div class="card-body">
    <h5 class="mt-4">
      {{ 'Common.SubscriptionTimeEnd1' | labelText }} <br />
      {{ 'Common.SubscriptionTimeEnd2' | labelText }}
      <span class="link-like mt-2" (click)="goToNewSubscription()">
        {{ 'Common.SubscriptionTimeEnd3' | labelText }}</span
      >.
    </h5>
  </div>
</div>
